export const TEST_ID = 'circleToolIcon';
